<div class="container">
  <div class="row">
      <h1 class="page-title">{{'RIDP_TITLE' | globalTranslate}}</h1>
  </div>
    <div class="ps-1 pb-1 hover-red">
        <div class="col text-start">
            <div tabindex="0" role="button" class="btn btn-link hover-red" (click)="onPrevious()" (keydown.enter)="onPrevious()" (keydown.space)="onPrevious(); $event.preventDefault()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16.875" height="15.75" viewBox="0 0 16.875 15.75">
                    <g id="_icons_arrow-back-outline" data-name="⚛️ icons/arrow-back-outline" transform="translate(0)">
                        <path id="Combined_Shape" data-name="Combined Shape"
                            d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
                            transform="translate(0)" fill="#174a7c" />
                    </g>
                </svg>
                <span class="ps-2">{{'BACK_TO_PREVIOUS_PAGE' | globalTranslate}}</span>
            </div>
        </div>
    </div>
<div class="bg-custom-register">
     <nh-doc-upload   [ridpFlow]="true" (docUploadSuccess)="documentUploaded($event)" >
    </nh-doc-upload>
</div>
  
</div>